// @import types
import { IHttpResponse } from 'app_types/httpTypes'
import { IUserData } from '../../userTypes'
import { IAttached } from '../attached/attached.types';
import { ISchedulingAssociation } from './courseSchedulingAssociationTypes'
// @end

// @add your types

export type TypeMaterialDelivery = 'digital' | 'physic' | 'none'

export enum ForceStatus {
  PROGRAMMED = 'programmed',
  CONFIRMED = 'confirmed',
  EXECUTED = 'executed',
  CANCELLED = 'cancelled',
}

export enum CourseSchedulingProvisioningMoodleStatus {
  IN_PROCESS = 'in-process',
  COMPLETED = 'completed',
  ERROR = 'error',
}

export enum CourseSchedulingStatus {
  CONFIRMED = 'Confirmado',
  PROGRAMMED = 'Programado',
  EXECUTED = 'Ejecutado',
  CANCELED = 'Cancelado'
}

export enum CourseSchedulingCourseType {
  MOOC = 'mooc',
  FREE = 'free',
}

export interface INewCourseScheduling {
  amountParticipants: number,
  city: {_id: string, name: string},
  country: {_id: string, name: string},
  client: {
    _id: string;
    name: string;
  },
  duration: number
  endDate: string,          // fecha de finalización
  in_design: boolean
  metadata: {user: any, date: string, service_id: string, year: string}
  modular: {_id: string, name: string}
  moodle_id: string
  observations: string,
  program: {
    _id: string,
    name: string,
    code: number,
    moodle_id: string
  }
  regional: {
    _id: string, // Identificador de la regional
    name: string, // Nombre de la regional
  },
  schedulingMode: {_id: string, name: string, moodle_id: string}
  schedulingStatus: {_id: string, name: string}
  schedulingType: {_id: string, name: string}
  course: {
    _id: string, // Identificador del curso
    name: string, // Nombre del curso
  },
  startDate: string,        // fecha de inicio
  teacher: {
    _id: string, // Identificador del usuario
    profile: {
      first_name: string, // Nombre del profesor
      last_name: string, // Apellidos del profesor
    },
  },
  total_scheduling: number
  material_delivery?: TypeMaterialDelivery
  business_report?: string
  partial_report?: string
  contact?: IUserData
  schedulingAssociation?: ISchedulingAssociation
  loadParticipants?: {
    loading: boolean;
    status?: 'success' | 'error';
    errors?: any[];
    success?: any[];
    lastUploadDate?: Date;
  }
  hasMultipleCertificate?: boolean
  multipleCertificate?: {
    status: boolean
    editingStatus: boolean
  }
  approval_criteria?: IAttached
  provisioningMoodle?: {
    status: CourseSchedulingProvisioningMoodleStatus
    logs: any[]
  }
  typeCourse?: CourseSchedulingCourseType
  serviceValidity?: number
  certificateCriteria?: string
  specialServiceConditions?: string
  certificatePrice?: {
    usd: string
    cop: string
  },
  certificationStrategy?: 'huella1' | 'huella2'
  isMultiple?: boolean
  serviceInformation?: string
  longServiceInformation?: string
 }

 export interface ICourseSchedulingListItem extends INewCourseScheduling {
  _id?: string
}

export interface ICourseSchedulingsHttpResponse extends IHttpResponse {
  schedulings: ICourseSchedulingListItem[]
  total_register: number
  pageNumber: number
  nPerPage: number
}

export interface ICourseSchedulingReport extends IHttpResponse {
  path: string
}

export interface ICourseSchedulingHttpResponse extends IHttpResponse {
  scheduling: INewCourseScheduling
  total_register: number
  pageNumber: number
  nPerPage: number
}
//@end
